import React from 'react'
import { Button, useToast } from '@sainsburys-tech/fable'
import PropTypes from 'prop-types'
import { Spark } from './Spark'
import { pushEventAndTrack } from '@/javascript/helpers/taggingSerializer'

const AskTrevorCTA = ({ name }) => {
  const [disabled, setDisabled] = React.useState(false)
  const toast = useToast()

  const onCTAClick = () => {
    const trevorDrawer = document.getElementById('trevor-drawer')
    if (trevorDrawer) {
      window.postMessage(
        { type: 'trevor-action', payload: { type: 'chat', action: 'productSummary', fields: { productName: name } } },
        window.location.origin
      )
    } else {
      setDisabled(true)
      toast?.addToast({
        type: 'error',
        label: 'Trevor is currently unavailable. Please try again later.'
      })
    }

    pushEventAndTrack({
      eventInfo: {
        eventAction: 'Summarise product',
        eventName: 'Trevor interaction'
      }
    })
  }

  return (
    <Button className='button-trevor-cta' onClick={onCTAClick} disabled={disabled}>
      <span className='button-trevor-icon'>
        <Spark />
      </span>
      <span className='button-trevor-label'>Summarise this product</span>
      <span className='button-trevor-image' aria-hidden='true' />
    </Button>
  )
}

AskTrevorCTA.propTypes = {
  name: PropTypes.string.isRequired
}

export default AskTrevorCTA
